/**
 * The sub-sub-categories worth a chip of their own: any that would show the
 * same label as the sub-category beside them, or as one already shown, add
 * nothing but a second copy.
 */
export const distinctSubSubCategories = (
  subCategory: string | undefined,
  subSubCategories: readonly string[] | undefined,
  label: (category: string) => string
): string[] => {
  const shown = new Set(subCategory ? [label(subCategory)] : []);
  return (subSubCategories ?? []).filter((category) => {
    const text = label(category);
    if (shown.has(text)) return false;
    shown.add(text);
    return true;
  });
};
